import React, { memo, useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Slider,
  Box,
  Typography,
  LoadingButton,
  TextField,
  Button,
  Switch,
  FormControlLabel,
  Icon,
  Divider,
} from "investira.react.components";
import { validators } from "investira.sdk";
import services from "../../../services";
import { VALIDATIONS } from "../../../const";
import withResponseHandling from "../../../hoc/withResponseHandling";
import { RangeSlider, DecimalTextField } from "../../../components/molecules";

const EnquadramentoRegrasEditDialog = memo((props) => {
  const { open, onClose, data, readData } = props;

  console.log(data);

  const [hasAlvo, setHasAlvo] = useState(false);
  const [insertType, setInsertType] = useState(true);

  const getMarks = (pLength = 11, pGap = 10) => {
    return Array.from({ length: pLength }, (_, xIndex) => {
      const xValue = xIndex * pGap;
      return {
        value: xValue,
        label: `${xValue}%`,
      };
    });
  };

  const getMarksAlvo = (pLength = 11, pMin = 0, pMax = 100) => {
    return Array.from({ length: pLength }, (_, xIndex) => {
      const xValue = Math.round(
        pMin + xIndex * ((pMax - pMin) / (pLength - 1))
      );
      return {
        value: xValue,
        label: `${xValue}%`,
      };
    });
  };

  const handleChange = (pFieldName, pFieldValue) => {
    formik.setFieldValue(pFieldName, pFieldValue, true);
  };

  const VALIDATION_SCHEMA = Yup.object().shape({
    enquadramento_regra_id: Yup.string().required(VALIDATIONS.REQUIRED),
    descricao: Yup.string().required(VALIDATIONS.REQUIRED),
    // minimo: Yup.number()
    //   .typeError("Mínimo deve ser um número")
    //   .min(0, "Mínimo não pode ser menor do que 0")
    //   .required(VALIDATIONS.REQUIRED),
    // maximo: Yup.number()
    //   .typeError("Máximo deve ser um número")
    //   .max(100, "Máximo não pode ser maior do que 100")
    //   .required(VALIDATIONS.REQUIRED),
    // alvo: Yup.number()
    //   .typeError("Alvo deve ser um número")
    //   .min(Yup.ref("minimo"), `Alvo não pode ser menor do que o mínimo`)
    //   .max(Yup.ref("maximo"), `Alvo não pode ser maior do que o máximo`)
    //   .required(VALIDATIONS.REQUIRED),
  });

  const formik = useFormik({
    initialValues: {
      enquadramento_id: data.enquadramento_id,
      enquadramento_regra_id: data.enquadramento_regra_id,
      alvo: data.alvo,
      minimo: data.minimo,
      maximo: data.maximo,
      descricao: data.descricao,
    },
    validationSchema: VALIDATION_SCHEMA,
    validateOnMount: true,
    onSubmit: (pValues, pActions) => {
      pActions.setSubmitting(true);
      services.enquadramentosRegras.modify(
        {
          data: { ...pValues },
        },
        (rRes) => {
          readData({ enquadramento_id: rRes.data.enquadramento_id });
          onClose && onClose();
        },
        (rErr) => {
          props.responseErrorHandling(rErr);
        },
        () => {
          pActions.setSubmitting(false);
        }
      );
    },
  });

  function handleChangeRange(pValue) {
    formik.setFieldValue("minimo", pValue[0]);
    formik.setFieldValue("maximo", pValue[1]);
  }

  useEffect(() => {
    !validators.isNull(data.alvo) && setHasAlvo(true);
  }, [data.alvo]);

  useEffect(() => {
    if (hasAlvo && formik.values.alvo <= formik.values.minimo) {
      formik.setFieldValue("alvo", formik.values.minimo);
    }

    if (hasAlvo && formik.values.alvo >= formik.values.maximo) {
      formik.setFieldValue("alvo", formik.values.maximo);
    }
  }, [hasAlvo, formik.values]);

  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth
      onClose={onClose}
      scroll="body"
      PaperProps={{ sx: { overflow: "visible" } }}
    >
      <DialogTitle>
        Editar Regra: {formik.values.enquadramento_regra_id}
      </DialogTitle>
      <DialogContent>
        <Stack pb={1}>
          <Typography variant="caption" color="textSecondary">
            {data.descricao}
          </Typography>
        </Stack>
        <Divider />
        <form noValidate onSubmit={formik.handleSubmit} autoComplete="off">
          <Stack
            direction="row"
            spacing={2}
            py={1}
            sx={{ justifyContent: "flex-end" }}
          >
            <FormControlLabel
              control={
                <Switch
                  checked={insertType}
                  onChange={() => {
                    setInsertType(!insertType);
                  }}
                  name="insertType"
                  size="small"
                />
              }
              label={
                <Typography color="textSecondary" variant="caption">
                  Alternar método de inserção
                </Typography>
              }
            />
            <FormControlLabel
              control={
                <Switch
                  checked={hasAlvo}
                  onChange={() => {
                    setHasAlvo(!hasAlvo);
                    formik.setFieldValue("alvo", null);
                  }}
                  name="hasAlvo"
                  size="small"
                />
              }
              label={
                <Typography color="textSecondary" variant="caption">
                  Habilitar Alvo
                </Typography>
              }
            />
          </Stack>
          <Divider />
          <Stack gap={2} sx={{ my: 1 }}>
            <Box>
              <Typography
                id="input-slider"
                variant="body2"
                color="textPrimary"
                gutterBottom
              >
                {`Minímo: ${formik.values.minimo}% - Máximo: ${formik.values.maximo}%`}
              </Typography>
              <RangeSlider
                label="Range Alvo"
                defaultValue={[formik.values.minimo, formik.values.maximo]}
                sliderProps={{
                  valueLabelDisplay: "auto",
                  marks: getMarks(5, 25),
                }}
                onChange={handleChangeRange}
              />
            </Box>
            <Box></Box>
            {hasAlvo && (
              <Box>
                {/* Slider */}
                {!insertType && (
                  <Stack flex="1">
                    <Typography
                      id="input-slider"
                      variant="body2"
                      color="textPrimary"
                      gutterBottom
                    >
                      Alvo: {`${formik.values.alvo}%`}
                    </Typography>
                    <Stack sx={{ mx: 2, my: 2 }}>
                      <Slider
                        label="Alvo"
                        name="alvo"
                        value={formik.values.alvo}
                        onChange={formik.handleChange}
                        track={false}
                        max={formik.values.maximo}
                        min={formik.values.minimo}
                        step={0.1}
                        valueLabelDisplay="auto"
                        marks={getMarksAlvo(
                          6,
                          formik.values.minimo,
                          formik.values.maximo
                        )}
                      />
                    </Stack>
                  </Stack>
                )}
                {/* Input */}
                {insertType && (
                  <Stack flex="1">
                    <DecimalTextField
                      label="Alvo"
                      name="alvo"
                      id="alvo"
                      variant="outlined"
                      value={formik.values.alvo}
                      placeholder={"100,00"}
                      onChange={(_, pValue) => handleChange("alvo", pValue)}
                      allowNegative={false}
                      decimal={2}
                      InputLabelProps={{ shrink: true }}
                      error={Boolean(formik.errors.alvo)}
                      helperText={formik.errors.alvo}
                      disabled={formik.isSubmitting}
                      fullWidth
                      InputProps={{
                        endAdornment: null,
                      }}
                    />
                  </Stack>
                )}
              </Box>
            )}
            <Box>
              <TextField
                id="descricao"
                name="descricao"
                label="Descrição"
                value={formik.values.descricao}
                onChange={formik.handleChange}
                placeholder="Digite uma descrição"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                error={Boolean(formik.errors.descricao)}
                helperText={formik.errors.descricao}
                disabled={formik.isSubmitting}
                fullWidth
              />
            </Box>
          </Stack>
          <Stack direction="row" justifyContent="flex-end" spacing={2}>
            <Button onClick={onClose}>Cancelar</Button>
            <LoadingButton
              variant="contained"
              color="primary"
              startIcon={<Icon iconName="save" size={16} />}
              sx={{ px: 2 }}
              type="submit"
              disabled={formik.isSubmitting || !formik.isValid}
              loading={formik.isSubmitting}
            >
              Salvar
            </LoadingButton>
          </Stack>
        </form>
      </DialogContent>
    </Dialog>
  );
});

export default withResponseHandling(EnquadramentoRegrasEditDialog);
